import { Component, computed, output } from '@angular/core';
import { SummarySectionComponent } from './components/summary-section/summary-section.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ClaimsFormService } from '../claims-form/services/claims-form.service';
import { ClaimJump } from '../../types/claim-form.types';

@Component({
  selector: 'app-summary-panel',
  imports: [SummarySectionComponent, ButtonComponent],
  templateUrl: './summary-panel.component.html',
  styleUrl: './summary-panel.component.scss',
  host: {
    class: 'p-40 lg-p-24 lg-pt-64  full-width max-w-400',
  },
})
export class SummaryPanelComponent {
  closePanel = output<void>();

  protected viewModel = computed(() => {
    const jumps = this.claimFormService.state.jumps;

    return {
      claimId: this.claimFormService.state.claimId,
      planNumber: this.claimFormService.state.planNumber,
      jumps: [
        {
          completed: true,
          direction: 'BACKWARDS',
          to: {
            step: 'claim-type',
          },
          values: [
            {
              type: 'TEXT',
              value: this.claimFormService.state.currentClaim?.state?.type,
            },
          ],
        } as ClaimJump,
        ...jumps,
      ],
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly claimFormService: ClaimsFormService) {}

  resumeStep(step: ClaimJump): void {
    this.claimFormService.resumeClaim(this.vm.claimId!, step.to.step, this.vm.planNumber, false, () => {
      console.log('Issue resuming the form!');
    });
  }
}
